import { useTranslation } from 'react-i18next';
import type { UiLocale } from '@translate-ai/shared';

/**
 * Returns the current UI locale narrowed to the supported `UiLocale` union.
 * Anything other than `'ru'` is treated as `'en'` so callers can index into
 * `{ en, ru }`-shaped maps without a cast.
 */
export function useUILocale(): UiLocale {
  const { i18n } = useTranslation();
  return i18n.resolvedLanguage === 'ru' ? 'ru' : 'en';
}
